import {
  SET_NOTIFICATIONS
} from './types'

const initialState = {
  notifications: []
}

const getters = {
  notifications: state => state.notifications,
  unreadNotifications: state => state.notifications.filter((n) => n.is_read === false).length
}

const mutations = {
  [SET_NOTIFICATIONS] (state, notifications) {
    state.notifications = notifications
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/notifications.js